/**
 * Created by Languagenut on 22/03/2019.
 */


import React  from 'react';
import {Media , Navbar , Form , Button , Card , Row , Col , Nav , NavDropdown} from 'react-bootstrap'
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';

export default class Help extends React.Component {


    constructor(props) {
        super();
        this.props = props;
        this.state = {

        };
    }

    componentDidMount() {

    }

    componentWillReceiveProps(props){

    }

    onNavigationSelect(){


    }

    render(){

        let row = [];

        for(var a = 0 ; a < 4; a++)
        {
            let video = [];
            for(var i = 0 ; i < 4; i++){
                video.push(
                    <Col md={3}>
                        <Media>
                            <img
                                width={80}
                                height={64}
                                className="mr-3"
                                src="https://dummyimage.com/16:9x1080/ccccccc/ffffff"
                                alt="Generic placeholder"
                                />
                            <Media.Body>
                                <b>Setting Up Students</b><br/>
                                <small>
                                    this is a description
                                </small>
                            </Media.Body>
                        </Media>
                    </Col>
                );
            }

            row.push(<Row>{video}</Row>);
            row.push(<br/>);
        }



        return <div>
                    <Card body>
                        <Row>
                            <Col md={6}><Card.Title>Help & Tutorials</Card.Title></Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                            <CarouselProvider naturalSlideWidth={100} naturalSlideHeight={50} totalSlides={3}>
                                <Slider>
                                    <Slide index={0}> <img
                                        className="mr-3"
                                        src="https://dummyimage.com/16:9x1080/ccccccc/ffffff"
                                        alt="Generic placeholder"
                                        /></Slide>
                                    <Slide index={1}>I am the second Slide.</Slide>
                                    <Slide index={2}>I am the third Slide.</Slide>
                                </Slider>
                            </CarouselProvider>
                            </Col>
                        </Row>
                        <br/>
                        <Row><Col md={12}><h6>Classes</h6></Col></Row>
                        {row}
                        <Row><Col md={12}><h6>Classes</h6></Col></Row>
                        {row}
                        <Row><Col md={12}><h6>Classes</h6></Col></Row>
                        {row}
                        <Row><Col md={12}><h6>Classes</h6></Col></Row>
                        {row}

                    </Card>
                </div>


    }

}